import { render, staticRenderFns } from "./VersionLib.vue?vue&type=template&id=ae74e274&scoped=true&"
import script from "./VersionLib.vue?vue&type=script&lang=js&"
export * from "./VersionLib.vue?vue&type=script&lang=js&"
import style0 from "./VersionLib.vue?vue&type=style&index=0&id=ae74e274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae74e274",
  null
  
)

export default component.exports